import React, {useMemo} from 'react';

import classNames from 'classnames';

import {QuoteItemV2} from 'api/magento/magentoAPI.schemas';
import {PRODUCT_TYPES} from 'constants/product';

import {MiniCartAccessoryItem} from '../miniCartProductItems/miniCartAccessoryItem/miniCartAccessoryItem';
import {MiniCartGlassesItem} from '../miniCartProductItems/miniCartGlassesItem/miniCartGlassesItem';
import {MiniCartLensesItem} from '../miniCartProductItems/miniCartLensesItem/miniCartLensesItem';
import {MiniCartLensesVistaItem} from '../miniCartProductItems/miniCartLensesVistaItem/miniCartLensesVistaItem';

import s from './productList.scss';

const sortProductsOutOfStock = (items?: QuoteItemV2[]) =>
    items?.length
        ? [...items]?.sort(
              (x, y) =>
                  Number(y.product.stock?.isOutOfStock) - Number(x.product.stock?.isOutOfStock),
          )
        : items;

type PropsType = {
    items: QuoteItemV2[];
    className?: {
        desktopContainer: string;
        dividerForDesktop: string;
    };
};

/**
 * Cart redesign products
 * @returns {React.ReactNode}
 */
export const ProductsList: React.FC<PropsType> = ({className, items}): React.JSX.Element => {
    const storeProductItems = useMemo(() => {
        const divider = classNames(s.divider, {
            [s.dividerForDesktop]: className?.dividerForDesktop,
        });
        return sortProductsOutOfStock(items)?.map((item, i, array) => {
            const {brand, type} = item.product;
            if (type === PRODUCT_TYPES.ACCESSORY) {
                return (
                    <div aria-label="Accessory item" key={item.id}>
                        <MiniCartAccessoryItem item={item} />
                        {i < array.length - 1 && <div className={divider} />}
                    </div>
                );
            }
            if (type === PRODUCT_TYPES.CONTACT_LENSES) {
                if (brand?.label === 'Vista Plus') {
                    return (
                        <div aria-label="Vista Plus item" key={item.id}>
                            <MiniCartLensesVistaItem item={item} />
                            {i < array.length - 1 && <div className={divider} />}
                        </div>
                    );
                }
                return (
                    <div aria-label="Lenses item" key={item.id}>
                        <MiniCartLensesItem item={item} />
                        {i < array.length - 1 && <div className={divider} />}
                    </div>
                );
            }

            return (
                <div aria-label="Cart item" key={item.id}>
                    <MiniCartGlassesItem item={item} key={item.id} />
                    {i < array.length - 1 && <div className={divider} />}
                </div>
            );
        });
    }, [items]);

    return (
        <div className={classNames(s.container, className?.desktopContainer)}>
            <div className={s.cartItems}>{storeProductItems}</div>
        </div>
    );
};
